import { inject, Injectable } from '@angular/core';
import { CookieHelperService, LoggingService } from '..';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private cookieHelper = inject(CookieHelperService);
  private logging = inject(LoggingService);

  private getLocationFromCookie(): string | null {
    const locationValue = this.cookieHelper.getCookieValue('location');
    return locationValue ? decodeURIComponent(locationValue) : null;
  }

  getUserCountry(): string {
    try {
      const userLocation = this.getLocationFromCookie();
      return userLocation?.split('+')[0] || '';
    } catch (error) {
      this.logging.log('User location failed ' + error);
      return '';
    }
  }
}
